<template>
  <div
    v-if="isLoadingEmbeddedPutOptionSymbolInfo"
    class="w-full h-16 flex items-center justify-center"
  >
    <NLoading class="text-brand-primary" />
  </div>

  <div v-else-if="embeddedPutOptionSymbolInfo" class="w-full h-16">
    <NText
      v-if="
        embeddedPutOptionSymbolInfo.requestType ===
        EMBEDDED_PUT_OPTION_REQUEST_TYPES.selective.value
      "
    >
      {{
        t('modules.portfolio.embeddedPutOption.infoMessage.selective', {
          physicalCount: embeddedPutOptionSymbolInfo.physicalRequestCount,
          maxCashThenPhysical:
            embeddedPutOptionSymbolInfo.firstCashRequestCount,
        })
      }}
    </NText>

    <NText
      v-else-if="
        embeddedPutOptionSymbolInfo.requestType ===
        EMBEDDED_PUT_OPTION_REQUEST_TYPES.maxCashThenPhysical.value
      "
    >
      {{
        t(
          'modules.portfolio.embeddedPutOption.infoMessage.maxCashThenPhysical',
          {
            count: embeddedPutOptionSymbolInfo.firstCashRequestCount,
          }
        )
      }}
    </NText>

    <NText v-else>
      {{
        t('modules.portfolio.embeddedPutOption.infoMessage.maxPhysical', {
          count: embeddedPutOptionSymbolInfo.physicalRequestCount,
        })
      }}
    </NText>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import {
  EMBEDDED_PUT_OPTION_REQUEST_TYPES,
  useGetEmbeddedPutOptionSymbolInfoQuery,
} from '@core/portfolio';

type EmbeddedPutOptionInfoDialogPropsType = {
  instrumentIsin: string;
};

const props = defineProps<EmbeddedPutOptionInfoDialogPropsType>();

const isin = ref<string>(props.instrumentIsin);

const { t } = useI18n();

const { embeddedPutOptionSymbolInfo, isLoadingEmbeddedPutOptionSymbolInfo } =
  useGetEmbeddedPutOptionSymbolInfoQuery({
    isin,
    immediate: true,
  });
</script>
